import baseService from '../shared/baseService';

const contentService = baseService('contents');

export default { 
    ...contentService
};

